import { createContext, useContext, useReducer } from 'react';
interface Context {
  drawerOpen: boolean;
}
let LayoutStateContext = createContext<Context>({
  drawerOpen: false,
});
let LayoutDispatchContext = createContext<{}>({});

function LayoutReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_DRAWER':
      return { ...state, drawerOpen: !state.drawerOpen };

    default: {
      throw new Error(`Error`);
    }
  }
}
const LayoutProvider: React.FC = ({ children }) => {
  let [state, dispatch] = useReducer(LayoutReducer, {
    drawerOpen: false,
  });
  return (
    <LayoutStateContext.Provider value={state}>
      <LayoutDispatchContext.Provider value={dispatch}>{children}</LayoutDispatchContext.Provider>
    </LayoutStateContext.Provider>
  );
};
function useLayoutState() {
  var context = useContext(LayoutStateContext);
  if (context === undefined) {
    throw new Error('Error');
  }
  return context;
}
function useLayoutDispatch() {
  let context = useContext(LayoutDispatchContext);
  if (context === undefined) {
    throw new Error('Error');
  }
  return context;
}
export { LayoutProvider, useLayoutState, useLayoutDispatch, toggleDrawer };

function toggleDrawer(dispatch) {
  dispatch({
    type: 'TOGGLE_DRAWER',
  });
}